// extracted by mini-css-extract-plugin
export default {"seeAllLinkButton":"MQevwr","seeAllLinkText":"n9fHRl","mobile":"FVzwRP"};